export default function Persongenre() {
  const persongenrearray = [
    'ఫిల్మ్ స్కోర్',
    'హిందుస్తానీ సంగీతం',
    'ఇండిపాప్',
    'బాలీవుడ్',
    'తమిళం',
    'తెలుగు',
    'ప్రపంచ సంగీతం',
    'సినిమా సంగీతం',
    'ఎలక్ట్రానిక్ సంగీతం',
    'కామెడీ సిరీస్',
    'హాస్య ధారావాహికలు',
    'తెలుగు జానపద సంగీతం',
    'వరల్డ్ మ్యూజిక్',
    'ప్లేబ్యాక్ గానం',
    'ఫిల్మి',
    'గజల్',
    'కర్ణాటిక్ సంగీతం',
    'శిల',
    'కలయిక',
    'బ్లూస్',
    'జానపద సంగీతం',
    'కర్ణాటక సంగీతం',
    'ర్యాపింగ్',
    'హిప్ హాప్ సంగీతం',
    'ఇండీ సంగీతం',
    'వివిధ',
    'ప్రపంచ సంగీత ప్రజలు',
    'హాస్య నృత్య ధారావాహికలు',
    'పాప్',
    'ప్లేబ్యాక్ సింగర్',
    'ఫ్యూజన్',
    'ఇంప్రెషనిస్ట్ (వినోదం)',
    'ఇండి-పాప్',
    'నృత్య సంగీతం',
    'శాస్త్రీయ సంగీతం',
    'థియేటర్',
  ]
  const arraypersonobj = persongenrearray.map(e => ({ value: e, selected: false }))
  return arraypersonobj
}
